import PropTypes from 'prop-types';
import React from 'react';
import { FaLock } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import { PlanBadge } from '../../PlanBadge';
import { ContentOverlay } from '../../ContentOverlay';

export const NoAccessOverlay = ({ children, warning }) => {
    const { t } = useTranslation('ui');

    if (!warning) {
        return children || null;
    }

    return (
        <ContentOverlay
            overlay={
                <>
                    <PlanBadge plan={warning.target}>
                        <FaLock size={8} />{' '}
                    </PlanBadge>
                    <div>{t(`NoAccess.${warning.code}.heading`, { target: warning.target || 'pro' })}</div>
                </>
            }
        >
            {children}
        </ContentOverlay>
    );
};

NoAccessOverlay.propTypes = {
    warning: PropTypes.shape({
        code: PropTypes.string.isRequired,
        plan: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
    }),
};
